import Service from "../../../Service";
import Axios from "../../../Config/API";
import { IListarProdutosReservadosResponse } from "../../../../Interfaces/Vendas/Produtos/GestaoReservas/GestaoReservasInterfaces";

export async function ListarProdutosReservadosService(nrPagina: number) {
    return Service(
        Axios.get<IListarProdutosReservadosResponse>(
            `/vendas/gestaoreservas/listarprodutosreservados?nrPagina=${nrPagina}`
        )
    );
}

export async function FinalizarReservaProdutoService(idProduto: number) {
    return Service(
        Axios.get<IListarProdutosReservadosResponse>(
            `/vendas/gestaoreservas/finalizarreservaproduto?idProduto=${idProduto}`
        )
    );
}
